module.exports = __webpack_public_path__ + "img/default1.ae863359.svg";